import React from 'react';

import {Flex} from "antd";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../components/UI/Text/MyText";
import DirectorApplicationList from "./Applications/DirectorApplicationList";
import {useDispatch, useSelector} from "react-redux";
import {getUserByToken} from "../../../../store/slices/userSlice";

const DirectorApplicationsPage = () => {
    const dispatch = useDispatch();
    const {user} = useSelector(state => state.user)
    if (user === null) {
        dispatch(getUserByToken());
    }
    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            {/* Отдельной страницы проректора больше нет: подписывает директор, согласование и
                подпись слиты в одну кнопку, поэтому обе роли видят один и тот же список. */}
            <MyText size={"large"} uppercase strong><IntlMessage id={'applications'}/></MyText>
            <DirectorApplicationList/>
        </Flex>
    );
};

export default DirectorApplicationsPage;